import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './GeneralSectorsComponent.module.scss';
import metadata from './GeneralSectorsComponent.metadata.json5';

function GeneralSectorsComponent(props) {

    const {
        data: GeneralSectorsVM,
        updateWizardData,
        submissionVM,
        GeneralSectorsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addGeneralSectors = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            GeneralSectorsVM.value = GeneralSectorsVM.value || []

            const { _xCenter, _dtoName } = GeneralSectorsVM;

            const GeneralSectorsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            GeneralSectorsObjVM.isValidationReq.value = true;

            GeneralSectorsVM.pushElement(
                GeneralSectorsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, GeneralSectorsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            GeneralSectorsVM.value.splice(index, 1);
            _.set(submissionVM.value, GeneralSectorsPath, GeneralSectorsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, GeneralSectorsPath, GeneralSectorsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'ser1') {
                const value = (item && item.ser1) ? item.ser1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = GeneralSectorsVM.length > 0 && GeneralSectorsVM.children[index].ser1
                    // eslint-disable-next-line security/detect-object-injection
                    ? GeneralSectorsVM.children[index].ser1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.ser1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'per2') {
                const value = item.per2 ? item.per2 : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.per2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={100}
                    />
                );
            }

            if (path === 'des3' && !_.isUndefined(item.ser1) && item.ser1 === 'OthSecPer') {
                const value = item.des3 ? item.des3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, GeneralSectorsVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`GeneralSectorsTable`]: {
            data: GeneralSectorsVM.value,
        }

    }), [GeneralSectorsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addGeneralSectors,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            GeneralSectorsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [GeneralSectorsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={GeneralSectorsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

GeneralSectorsComponent.propTypes = wizardProps;
export default withRouter(GeneralSectorsComponent);
